export const widgetCss = `
:host { all: initial; }
* { box-sizing: border-box; font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; }
.wrap {
  position: fixed; z-index: 2147483646;
  --inclusive-primary: #a8c030;
  --inclusive-primary-hover: #8eab24;
  --inclusive-primary-border: #d9e0b8;
  --inclusive-primary-text: #111111;
  --inclusive-primary-contrast: #111111;
  --inclusive-primary-light: #f4f8e6;
  --inclusive-primary-active: #eef4d4;
  --inclusive-primary-dark: #3f4a2a;
  --inclusive-primary-shadow: rgba(142, 171, 36, 0.35);
  --inclusive-primary-shadow-hover: rgba(142, 171, 36, 0.45);
  --inclusive-primary-ring: rgba(168, 192, 48, 0.25);
}
.wrap.bottom-right { right: max(1rem, env(safe-area-inset-right)); bottom: max(1.25rem, env(safe-area-inset-bottom)); }
.wrap.bottom-left { left: max(1rem, env(safe-area-inset-left)); bottom: max(1.25rem, env(safe-area-inset-bottom)); }
.wrap.top-right { right: max(1rem, env(safe-area-inset-right)); top: max(1.25rem, env(safe-area-inset-top)); }
.wrap.top-left { left: max(1rem, env(safe-area-inset-left)); top: max(1.25rem, env(safe-area-inset-top)); }
.button {
  display: inline-flex; align-items: center; justify-content: center;
  width: 3.65rem; height: 3.65rem; min-width: 3.65rem; min-height: 3.65rem;
  border-radius: 50%; border: 2.5px solid #8eab24; border-color: var(--inclusive-primary-hover, #8eab24);
  background: #a8c030;
  background: var(--inclusive-primary, #a8c030);
  color: #111111;
  color: var(--inclusive-primary-text, #111111);
  box-shadow: 0 8px 24px rgba(17, 17, 17, 0.22), 0 2px 6px var(--inclusive-primary-shadow, rgba(142, 171, 36, 0.35));
  padding: 0; position: relative;
  cursor: pointer;
  transition: transform 180ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 180ms ease, background 150ms ease;
}
.button:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 12px 30px rgba(17, 17, 17, 0.28), 0 4px 10px var(--inclusive-primary-shadow-hover, rgba(142, 171, 36, 0.45));
}
.button:active { transform: translateY(0) scale(0.96); }
.button svg { width: 1.85rem; height: 1.85rem; flex-shrink: 0; }
.button-label {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}
.button[aria-expanded="true"] {
  box-shadow: 0 0 0 3px #111111, 0 12px 30px rgba(17, 17, 17, 0.25);
}
.button:focus-visible { outline: 3px solid #111111; outline-offset: 3px; }
.button-badge {
  position: absolute; top: -3px; right: -3px;
  min-width: 1.3rem; height: 1.3rem; padding: 0 0.3rem;
  border-radius: 999px; background: #111111; color: var(--inclusive-primary, #a8c030);
  border: 2px solid #ffffff; font-size: 0.68rem; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  line-height: 1; pointer-events: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.panel {
  position: absolute; width: min(28.5rem, calc(100vw - 1.5rem));
  max-height: min(44rem, calc(100vh - 5.5rem));
  display: flex; flex-direction: column; overflow: hidden;
  background: #ffffff; color: #111111; border: 1px solid var(--inclusive-primary-border, #d9e0b8); border-radius: 16px;
  box-shadow: 0 20px 50px -10px rgba(17, 17, 17, 0.22), 0 0 0 1px var(--inclusive-primary-border, rgba(217, 224, 184, 0.4));
}
.wrap.bottom-right .panel, .wrap.bottom-left .panel { bottom: 4.75rem; top: auto; }
.wrap.top-right .panel, .wrap.top-left .panel { top: 4.75rem; bottom: auto; }
.wrap.bottom-right .panel, .wrap.top-right .panel { right: 0; left: auto; }
.wrap.bottom-left .panel, .wrap.top-left .panel { left: 0; right: auto; }
.header {
  display: flex; justify-content: space-between; align-items: center; gap: 0.75rem;
  padding: 0.85rem 1.1rem; background: var(--inclusive-primary-light, #f4f8e6); border-bottom: 1px solid var(--inclusive-primary-border, #d9e0b8);
}
.heading { display: flex; flex-direction: column; gap: 0.15rem; }
.header-top { display: flex; align-items: center; gap: 0.5rem; }
.brand { margin: 0; font-size: 0.7rem; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; color: var(--inclusive-primary-dark, #3f4a2a); }
.active-pill {
  display: inline-flex; align-items: center; gap: 0.25rem;
  font-size: 0.65rem; font-weight: 700; padding: 0.15rem 0.45rem;
  border-radius: 999px; background: var(--inclusive-primary, #a8c030); color: var(--inclusive-primary-text, #111111); line-height: 1;
}
.title { margin: 0; font-size: 1.1rem; font-weight: 800; letter-spacing: -0.01em; color: #111111; }
.close {
  flex-shrink: 0; width: 2.25rem; height: 2.25rem; border-radius: 8px;
  border: 1px solid var(--inclusive-primary-border, #d9e0b8); background: #ffffff; color: #111111; cursor: pointer; font-size: 1.25rem; line-height: 1;
  display: flex; align-items: center; justify-content: center;
  transition: background 140ms ease, border-color 140ms ease, transform 140ms ease;
}
.close:hover { background: var(--inclusive-primary-active, #eef4d4); border-color: var(--inclusive-primary-hover, #8eab24); transform: scale(1.05); }
.close:active { transform: scale(0.95); }
.body { padding: 0.85rem 1.1rem 0.5rem; overflow-y: auto; overflow-x: hidden; }
.footer { padding: 0.85rem 1.1rem 1rem; border-top: 1px solid var(--inclusive-primary-border, #d9e0b8); background: #fafbf6; }
.close:focus-visible, .action:focus-visible, .chip:focus-visible, .lang-chip:focus-visible, .lang-search-input:focus-visible, .position-btn:focus-visible, select:focus-visible, .switch input:focus-visible + .track {
  outline: 3px solid #111111; outline-offset: 2px;
}
.section {
  margin: 1rem 0 0.45rem; font-size: 0.72rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; color: var(--inclusive-primary-dark, #3f4a2a);
  display: flex; align-items: center; justify-content: space-between;
}
.section:first-child { margin-top: 0.1rem; }
.profiles { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.55rem; margin: 0.45rem 0 0.95rem; }
.chip {
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0.45rem;
  border: 1px solid var(--inclusive-primary-border, #d9e0b8); background: #fafbf6; color: #111111; border-radius: 12px;
  padding: 0.75rem 0.5rem; cursor: pointer; font-size: 0.82rem; font-weight: 600; min-height: 5.25rem;
  text-align: center; line-height: 1.25;
  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease, background 140ms ease;
}
.chip:hover { background: var(--inclusive-primary-light, #f4f8e6); border-color: var(--inclusive-primary-hover, #8eab24); transform: translateY(-1px); }
.chip[aria-pressed="true"] {
  background: var(--inclusive-primary, #a8c030); color: var(--inclusive-primary-text, #111111); border-color: var(--inclusive-primary-hover, #8eab24); font-weight: 800;
  box-shadow: 0 3px 8px var(--inclusive-primary-shadow, rgba(142, 171, 36, 0.28));
}
.chip-icon {
  width: 1.65rem; height: 1.65rem; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.chip-icon svg { width: 1.45rem; height: 1.45rem; }
.chip-name { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%; font-size: 0.82rem; font-weight: 700; }
.cards-grid {
  display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.65rem; margin: 0.45rem 0 1rem;
}
.switch-row {
  display: flex; flex-direction: column; justify-content: space-between; gap: 0.65rem;
  padding: 0.85rem 0.85rem 0.75rem; border-radius: 12px;
  background: #fafbf6; border: 1px solid var(--inclusive-primary-border, #d9e0b8); cursor: pointer;
  position: relative; min-height: 5.4rem; user-select: none;
  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease, background 140ms ease;
  box-shadow: 0 1px 3px rgba(17, 17, 17, 0.04);
}
.switch-row:hover {
  background: var(--inclusive-primary-light, #f4f8e6); border-color: var(--inclusive-primary-hover, #8eab24); transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(17, 17, 17, 0.07);
}
.switch-row:has(input:checked), .switch-row.is-active {
  background: var(--inclusive-primary-active, #eef4d4); border-color: var(--inclusive-primary-hover, #8eab24);
  box-shadow: 0 2px 8px var(--inclusive-primary-shadow, rgba(142, 171, 36, 0.18));
}
.switch-row:has(input:checked) .card-icon, .switch-row.is-active .card-icon {
  background: var(--inclusive-primary, #a8c030); color: var(--inclusive-primary-text, #111111);
}
.card-top {
  display: flex; justify-content: space-between; align-items: center; width: 100%;
}
.card-icon {
  width: 2.35rem; height: 2.35rem; border-radius: 9px;
  display: inline-flex; align-items: center; justify-content: center;
  background: var(--inclusive-primary-light, #f0f4dc); color: var(--inclusive-primary-dark, #3f4a2a); flex-shrink: 0;
  transition: background 140ms ease, color 140ms ease;
}
.card-icon svg { width: 1.35rem; height: 1.35rem; }
.card-label {
  font-size: 0.88rem; font-weight: 650; line-height: 1.3; color: #111111;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.switch { position: relative; width: 2.55rem; height: 1.45rem; flex-shrink: 0; }
.switch input { position: absolute; inset: 0; opacity: 0; margin: 0; cursor: pointer; }
.track {
  display: block; width: 100%; height: 100%; background: var(--inclusive-primary-border, #d9e0b8); border-radius: 999px; position: relative;
  transition: background 150ms ease;
}
.track::after {
  content: ""; position: absolute; top: 0.15rem; left: 0.15rem;
  width: 1.15rem; height: 1.15rem; background: #111111; border-radius: 999px;
  transition: transform 150ms ease;
}
.switch input:checked + .track { background: var(--inclusive-primary, #a8c030); }
.switch input:checked + .track::after { transform: translateX(1.1rem); }
.control-card {
  background: #fafbf6; border: 1px solid var(--inclusive-primary-border, #d9e0b8); border-radius: 12px;
  padding: 0.85rem 0.95rem; margin: 0.45rem 0 1rem;
  box-shadow: 0 1px 3px rgba(17, 17, 17, 0.04);
}
.control-info { display: flex; align-items: center; gap: 0.65rem; }
.control-icon {
  width: 2.2rem; height: 2.2rem; border-radius: 8px;
  display: inline-flex; align-items: center; justify-content: center;
  background: var(--inclusive-primary-light, #f0f4dc); color: var(--inclusive-primary-dark, #3f4a2a); flex-shrink: 0;
}
.control-icon svg { width: 1.25rem; height: 1.25rem; }
.control-label { font-size: 0.92rem; font-weight: 700; color: #111111; }
.row { display: flex; justify-content: space-between; align-items: center; gap: 0.75rem; }
.stepper { display: flex; align-items: center; gap: 0.45rem; }
.stepper strong {
  min-width: 2.75rem; text-align: center; font-size: 0.92rem; font-weight: 800; color: #111111;
}
.stepper .action {
  width: 2.35rem; min-width: 2.35rem; height: 2.35rem; min-height: 2.35rem; padding: 0;
  display: inline-flex; align-items: center; justify-content: center;
  border-radius: 8px; font-size: 1.2rem; font-weight: 700;
}
.lang-active-badge {
  font-size: 0.72rem; font-weight: 700; color: var(--inclusive-primary-dark, #3f4a2a);
  background: var(--inclusive-primary-active, #eef4d4); padding: 0.2rem 0.55rem; border-radius: 999px;
  border: 1px solid var(--inclusive-primary-border, #d9e0b8); margin-left: auto;
}
.lang-chips {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.4rem;
  margin: 0.55rem 0 0.45rem;
}
.lang-chip {
  display: inline-flex; align-items: center; justify-content: center; gap: 0.35rem;
  padding: 0.45rem 0.35rem; border-radius: 8px; border: 1px solid var(--inclusive-primary-border, #d9e0b8);
  background: #ffffff; color: #111111; font-size: 0.78rem; font-weight: 600;
  cursor: pointer; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  transition: transform 140ms ease, background 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}
.lang-chip:hover {
  background: var(--inclusive-primary-light, #f4f8e6); border-color: var(--inclusive-primary-hover, #8eab24); transform: translateY(-1px);
}
.lang-chip[aria-pressed="true"] {
  background: var(--inclusive-primary, #a8c030); color: var(--inclusive-primary-text, #111111); border-color: var(--inclusive-primary-hover, #8eab24); font-weight: 800;
  box-shadow: 0 2px 6px var(--inclusive-primary-shadow, rgba(142, 171, 36, 0.28));
}
.lang-code-pill {
  font-size: 0.62rem; font-weight: 800; text-transform: uppercase;
  background: rgba(17, 17, 17, 0.08); padding: 0.1rem 0.25rem; border-radius: 4px;
}
.lang-chip[aria-pressed="true"] .lang-code-pill {
  background: rgba(17, 17, 17, 0.16);
}
.lang-search-wrap {
  position: relative; width: 100%; margin: 0.45rem 0 0.35rem;
}
.lang-search-icon {
  position: absolute; left: 0.65rem; top: 50%; transform: translateY(-50%);
  width: 1rem; height: 1rem; color: #6b7280; pointer-events: none;
  display: inline-flex; align-items: center; justify-content: center;
}
.lang-search-icon svg { width: 0.95rem; height: 0.95rem; }
.lang-search-input {
  width: 100%; border: 1px solid var(--inclusive-primary-border, #d9e0b8); background: #ffffff; color: #111111; border-radius: 8px;
  padding: 0.5rem 0.65rem 0.5rem 2rem; font-size: 0.82rem; font-weight: 500;
  outline: none; transition: border-color 140ms ease, box-shadow 140ms ease;
}
.lang-search-input:focus {
  border-color: var(--inclusive-primary-hover, #8eab24); box-shadow: 0 0 0 3px var(--inclusive-primary-ring, rgba(168, 192, 48, 0.25));
}
.select-wrap { position: relative; width: 100%; margin-top: 0.45rem; }
select {
  width: 100%; border: 1px solid var(--inclusive-primary-border, #d9e0b8); background: #ffffff; color: #111111; border-radius: 8px;
  padding: 0.55rem 0.75rem; cursor: pointer; font-size: 0.88rem; font-weight: 500; min-height: 2.5rem;
  appearance: none; -webkit-appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="%233f4a2a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>');
  background-repeat: no-repeat; background-position: right 0.75rem center; background-size: 1rem;
}
select:hover { border-color: var(--inclusive-primary-hover, #8eab24); }
.field-stack { display: flex; flex-direction: column; gap: 0.55rem; }
.actions { display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; }
.action {
  border: 1px solid var(--inclusive-primary-hover, #8eab24); background: #ffffff; color: #111111; border-radius: 8px;
  padding: 0.55rem 0.75rem; cursor: pointer; font-size: 0.9rem; font-weight: 700; min-height: 2.65rem;
  display: inline-flex; align-items: center; justify-content: center; gap: 0.35rem;
  transition: transform 140ms ease, background 140ms ease, box-shadow 140ms ease;
}
.action:hover { background: var(--inclusive-primary-light, #f4f8e6); transform: translateY(-1px); }
.action:active { transform: translateY(0); }
.action[aria-pressed="true"] {
  background: var(--inclusive-primary, #a8c030); color: var(--inclusive-primary-text, #111111); border-color: var(--inclusive-primary-hover, #8eab24);
  box-shadow: 0 2px 8px var(--inclusive-primary-shadow, rgba(142, 171, 36, 0.25));
}
.reset { background: var(--inclusive-primary, #a8c030); color: var(--inclusive-primary-text, #111111); border-color: var(--inclusive-primary-hover, #8eab24); }
.reset:hover { background: var(--inclusive-primary-hover, #97ad2b); }
.status {
  font-size: 0.8rem; color: var(--inclusive-primary-dark, #3f4a2a); margin: 0.6rem 0 0; line-height: 1.4;
  background: var(--inclusive-primary-light, #f4f8e6); border: 1px solid var(--inclusive-primary-border, #d9e0b8); border-radius: 8px; padding: 0.6rem 0.75rem;
}
.status.is-failed { background: #ffffff; border-color: var(--inclusive-primary-border, #d9e0b8); }
.disclaimer { font-size: 0.72rem; color: var(--inclusive-primary-dark, #3f4a2a); margin: 0.65rem 0 0; line-height: 1.4; }
.nita-brand {
  display: flex; align-items: center; gap: 0.6rem;
  margin: 0.75rem 0 0; padding: 0.55rem 0.75rem;
  background: #ffffff; border: 1px solid var(--inclusive-primary-border, #d9e0b8); border-radius: 8px;
  color: #111111; text-decoration: none;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}
.nita-brand:hover { border-color: var(--inclusive-primary-hover, #8eab24); box-shadow: 0 2px 8px var(--inclusive-primary-shadow, rgba(142, 171, 36, 0.15)); }
.nita-logo { height: 1.85rem; width: auto; max-width: 7.25rem; object-fit: contain; flex-shrink: 0; }
.nita-credit { font-size: 0.68rem; font-weight: 600; line-height: 1.35; color: var(--inclusive-primary-dark, #3f4a2a); }
.sr-only {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}
@media (prefers-reduced-motion: no-preference) {
  .wrap.bottom-right .panel, .wrap.bottom-left .panel { animation: inclusive-panel-in 180ms ease-out; }
  .wrap.top-right .panel, .wrap.top-left .panel { animation: inclusive-panel-in-top 180ms ease-out; }
  .track, .track::after { transition: background 150ms ease, transform 150ms ease; }
}
@media (prefers-reduced-motion: reduce) {
  .panel { animation: none; }
  .track, .track::after { transition: none; }
}
@keyframes inclusive-panel-in {
  from { opacity: 0; transform: translateY(0.5rem); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes inclusive-panel-in-top {
  from { opacity: 0; transform: translateY(-0.5rem); }
  to { opacity: 1; transform: translateY(0); }
}
@media (max-width: 480px) {
  .panel { width: calc(100vw - 1.5rem); }
  .actions { grid-template-columns: 1fr; }
}
@media (max-width: 360px) {
  .profiles { grid-template-columns: repeat(2, 1fr); }
  .cards-grid { grid-template-columns: 1fr; }
  .lang-chips { grid-template-columns: repeat(2, 1fr); }
}
`;
